import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { REDIRECT_PATH } from "../lib/socialpulseOidc";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SocialPulseCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const storedState = sessionStorage.getItem("sp_oauth_state");
    const verifier = sessionStorage.getItem("sp_pkce_verifier");
    if (!code || !verifier || state !== storedState) {
      setError("Invalid sign-in state. Please try again.");
      setTimeout(() => navigate("/"), 2500);
      return;
    }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/socialpulse/callback`, {
          code,
          code_verifier: verifier,
          redirect_uri: window.location.origin + REDIRECT_PATH,
        }, { withCredentials: true });
        sessionStorage.removeItem("sp_oauth_state");
        sessionStorage.removeItem("sp_pkce_verifier");
        setUser(res.data);
        navigate("/community");
      } catch {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/"), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]" data-testid="socialpulse-callback">
      <div className="text-center">
        <p className="text-xl font-extrabold text-[#0A2540]">SportsPulse<span className="text-[#0055FF]">.pro</span></p>
        <div className="mx-auto mt-4 h-10 w-10 animate-spin rounded-full border-4 border-[#0055FF] border-t-transparent" />
        <p className="mt-4 text-sm font-semibold text-slate-600">{error || "Signing you in…"}</p>
        <p className="mt-2 text-[11px] font-semibold text-slate-400">Powered by SocialPulse</p>
      </div>
    </div>
  );
}
